import { ContenidoPlano, SeccionPlano, NodoPlano } from 'interiores-mapa';
export class AlaFormulario {
	// Alimentar los inputs
	Id: string;
	Nomobre: string;
	Descripcion: string;
	Imagen: any;
	RutaImagen: any;
	editarVisible: boolean;
	seleccionarVisible: boolean;

	FechaAlta: Date;
	FechaBaja: Date;

	zoomMinimo: Number;
	zoomMaximo: Number;
	zoomMaximoRuta: Number;
	zoomMinimoLabel: Number;

	IconoNodoScale: number;
	IconoContenidoScale: number;

	ConexionScale: number;
	AristaSeccionScale: number;
	PuntoConexionScale: number;
	PuntoSeccionScale: number;

	backgroundColor: string;

	Idiomas: Map<string, AlaIdiomaFormulario>;

	// Objeto de Breeze
	ENTIDAD: any;
	TIPO: string;
	GEOCALIBRACION_ALA: any;
	numeroCONTENIDOS: Number = 0;

	// Añadido para controlar componente plano desde la vista informes

	zoomLevels: any[];
	currentZoomLevel: number;
	pathSvgPlano: any;
	pathPlano: any;
	compass: any;
/*
	mapSections: Map<String, SeccionPlano> = new Map<String, SeccionPlano>();
	mapNodes: Map<String, NodoPlano> = new Map<String, NodoPlano>();
	mapContents: Map<String, ContenidoPlano> = new Map<String, ContenidoPlano>();

	contents: ContenidoPlano[] = [];
	nodes: NodoPlano[] = [];
	sections: SeccionPlano[] = [];
*/
	constructor(ala?) {
		this.Nomobre = '';
		this.Descripcion = '';
		this.Imagen = '';
		this.RutaImagen = '';
		this.editarVisible = false;
		this.seleccionarVisible = false;

		this.zoomMinimo = 1;
		this.zoomMaximo = 1;
		this.zoomMaximoRuta = 1;
		this.zoomMinimoLabel = 1;

		this.IconoNodoScale = 1;
		this.IconoContenidoScale = 1;
		this.ConexionScale = 1;
		this.AristaSeccionScale = 1;
		this.PuntoConexionScale = 1;
		this.PuntoSeccionScale = 1;
		this.backgroundColor = 'rgba(163,0,255,1)';

		this.Idiomas = new Map<string, AlaIdiomaFormulario>();

		this.ENTIDAD = {};
		this.numeroCONTENIDOS = 0;

		if (ala) {
			this.ENTIDAD = ala;
			this.Id = ala.Id;
			this.Nomobre = ala.Nomobre;
			this.Descripcion = ala.Descripcion;
			this.TIPO = ala.constructor.name.split('_', 2)[0];
			this.Imagen = ala.RutaImagen;
			this.RutaImagen = ala.RutaImagen;

			this.FechaAlta = ala.FechaAlta;
			this.FechaBaja = ala.FechaBaja;

			this.zoomMinimo = ala.zoomMinimo;
			this.zoomMaximo = ala.zoomMaximo;
			this.zoomMaximoRuta = ala.zoomMaximoRuta;
			this.zoomMinimoLabel = ala.zoomMinimoLabel;

			this.IconoNodoScale = ala.IconoNodoScale;
			this.IconoContenidoScale = ala.IconoContenidoScale;

			this.backgroundColor = ala.backgroundColor;

			ala.IDIOMAS.forEach(element => {
				const aux = new AlaIdiomaFormulario(element);
				this.Idiomas.set(element.IDIOMA.Codigo, aux);
			});

			if (ala.CONTENIDOS){
				this.numeroCONTENIDOS = ala.CONTENIDOS.length;
			}
		}

	}
}


export class AlaIdiomaFormulario {

	Codigo: string;
	Nombre: string;
	Descripcion: string;

	constructor(alaIdioma?) {

		if (alaIdioma) {
			this.Codigo = alaIdioma.IDIOMA.Codigo ? alaIdioma.IDIOMA.Codigo : '';
			this.Nombre =  alaIdioma.Nombre ? alaIdioma.Nombre : '';
			this.Descripcion = alaIdioma.Descripcion ? alaIdioma.Descripcion : '';
		}
		else{
			this.Codigo = '';
			this.Nombre = '';
			this.Descripcion = '';
		}

	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/AlaFormulario.ts